import { reactive, toRefs } from 'vue';

const data = reactive({
   params: {}//配色参数整合
});
const methods = {
   delParams() {
      data.params = {}
   }
};
export default {
   data,
   ...toRefs(data),
   ...methods,
}